import * as React from "react";
import { WifiOff } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import type { LineSummary } from "@/types/lines.types";

interface Props {
  line: LineSummary;
  pauseEta: string | null;
  selected: boolean;
  onToggleSelect?: () => void;
}

const CHECKBOX =
  "mt-1 h-4 w-4 shrink-0 cursor-pointer appearance-none rounded-[4px] border-[1.5px] border-border-strong bg-bg-surface " +
  "checked:border-brand-600 checked:bg-brand-600 " +
  "relative checked:after:absolute checked:after:left-[3px] checked:after:top-[1px] " +
  "checked:after:h-[8px] checked:after:w-[5px] checked:after:rotate-45 " +
  "checked:after:border-b-[1.5px] checked:after:border-r-[1.5px] checked:after:border-white " +
  "checked:after:content-[''] focus-visible:outline-none focus-visible:[box-shadow:var(--rd-shadow-focus)]";

export function LineCardTitleBlock({
  line,
  pauseEta,
  selected,
  onToggleSelect,
}: Props): React.ReactElement {
  const offline = (line.sensorHealth?.offline ?? 0) + (line.sensorHealth?.inconsistent ?? 0);
  const showSensorAlert = offline > 0;

  return (
    <div className="flex min-w-0 items-start gap-2.5">
      {onToggleSelect ? (
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggleSelect}
          onClick={(e) => e.stopPropagation()}
          aria-label={`Selecionar ${line.name}`}
          className={CHECKBOX}
        />
      ) : null}
      <div className="min-w-0 flex-1 space-y-1">
        {}
        <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
          <h3 className="text-[16px] font-semibold tracking-[-0.01em] text-text-primary">
            {line.name}
          </h3>
          <StatusBadge status={line.status} effectiveStatus={line.effectiveStatus} kind="line" />
          {pauseEta ? (
            <span className="text-[12px] text-text-secondary">
              · <b className="font-medium text-text-primary">retomar em {pauseEta}</b>
            </span>
          ) : null}
        </div>

        {}
        {line.description || line.responsible ? (
          <p className="text-[12px] text-text-secondary">
            {line.description}
            {line.description && line.responsible ? " · " : ""}
            {line.responsible}
          </p>
        ) : null}

        {}
        {showSensorAlert ? (
          <p
            role="status"
            className="border-rd-danger-500/30 inline-flex items-center gap-1.5 rounded-full border bg-rd-danger-50 px-2 py-0.5 text-[11px] font-medium text-rd-danger-700"
          >
            <WifiOff className="h-3 w-3" aria-hidden="true" />
            {offline} {offline === 1 ? "sensor sem comunicação" : "sensores sem comunicação"}
          </p>
        ) : null}
      </div>
    </div>
  );
}
